import styled from 'styled-components/macro';

const Main = styled.main`
  flex: 1;
`;

export default Main;
